import { registerWidget, IWidget, IWidgetDefinition, IBaseSettings } from '../../common/core';

const template = require('./fuse-mobile-filters.html');
const styles = require('./fuse-mobile-filters.scss').toString();

export interface IFuseMobileFiltersSettings extends IBaseSettings {
    /**
     * Selected filters template (optional)
     */
    selectedFiltersTemplate?: string;

    /**
     * Optional filter for widgets to show in mobile filter modal
     */
    filter?: (widget: IWidget<FuseMobileFiltersData, IFuseMobileFiltersSettings, null>, filters: any[]) => any[];
}

class FuseMobileFiltersData {
    allFilters: any[];
    subFiltersW: any;
    widgetData: any[];

    public isOpenModal: boolean = false
    constructor(public widget: IWidget<FuseMobileFiltersData, IFuseMobileFiltersSettings, null>) {

    }

    toggleShowModal() {
        this.isOpenModal = !this.isOpenModal;

        this.unsubscribeEvents();
        if (this.isOpenModal) {
            this.subsctibeEvents();
        }
    }

    _globalEscKeydownHandler(event) {
        var key = event.which;
        switch (key) {
            case 27:
                // Esc enter.
                this.toggleShowModal();
                event.preventDefault(); // prevent form submit (for embed view)
                break;
        }
    }

    globalEscKeydownHandler = (event) => {
        this.widget.service['zone'].run(() => {
            this._globalEscKeydownHandler(event);
        });
    };

    subsctibeEvents() {
        this.widget.service['zone'].runOutsideAngular(() => {
            document.addEventListener('keydown', this.globalEscKeydownHandler);
        });
    }

    unsubscribeEvents() {
        this.widget.service['zone'].runOutsideAngular(() => {
            document.removeEventListener('keydown', this.globalEscKeydownHandler);
        });
    }

    cancelCloseModal() {
        this.toggleShowModal()
    }
    afterInit() {
        var allWidgets = this.widget.service.getAllWidgets();

        this.allFilters = allWidgets.filter(item => {
            return item.type === 'fuse-textfacet' || item.type === 'fuse-date-range' || item.type === "fuse-treefacet" || item.type === "fuse-field-date-picker";
        });
        this.subFiltersW = allWidgets.find(item => {
            return item.type === 'fuse-subfilters';
        });
    }
    beforeSearch() {
        // find necessary items
        var filtersArr = this.allFilters;
        if (this.widget.settings.filter) {
            filtersArr = this.widget.settings.filter(this.widget, filtersArr);
        }
        this.widgetData = filtersArr;
    }

    destroy() {
        this.unsubscribeEvents();
    }
}

const FuseMobileFiltersWidgetDefinition: IWidgetDefinition<FuseMobileFiltersData, IFuseMobileFiltersSettings, null> = {
    init(widget) {
        widget.data = new FuseMobileFiltersData(widget);
    },
    beforeSearch(widget) {
        widget.data.beforeSearch();
    },
    afterInit(widget) {
        widget.data.afterInit();
    },
    destroy(widget) {
        if (widget.data.destroy) {
            widget.data.destroy();
        }
    },
    template,
    styles,
};

registerWidget('fuse-mobile-filters', FuseMobileFiltersWidgetDefinition)